@if (verifyEmailOtpForm$ | async; as form) {
  <form
    [ngrxFormState]="form"
    (submit)="onSubmit(form)"
    >
    <div>
      <h5 class="text-muted fw-normal mb-4">
        Inserisci il codice di verifica che hai ricevuto alla mail con cui
        effettui l'accesso.
      </h5>
      <div>
        <ideapa-otp-field
          [label]="'Codice di verifica'"
          [ngrxFormControlState]="form.controls.otpCode"
          [errors]="form.controls.otpCode.errors | ngrxFormsErr"
          [shouldShowError]="form.controls.otpCode.isInvalid && form.controls.otpCode.isSubmitted"
        ></ideapa-otp-field>
      </div>
    </div>
    <div class="mt-3 text-end">
      <ideapa-button
        type="submit"
        [cssClasses]="'btn-primary'"
        [text]="'Accedi'"
      ></ideapa-button>
    </div>
  </form>
}
